<template>
  <component
    is="div"
    ref="InnerBoxRef"
    v-bind="$attrs"
    :class="[
      'border rounded-xl p-3',
      error ? 'border-accent outline outline-accent' : 'border-stroke-neutral-disabled'
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

interface Props {
  as?: string | Component
  error?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  error: false
})
</script>
